import gql from 'graphql-tag';

const query = gql`
  query DailyTrackerActivity($id: Int!) {
    dailyTracker {
      activity(id: $id) {
        id
        sourceType
        name
        activityType
        caloriesBurned
        durationSeconds
        imageUrl
        loggedAt
        distance
        distanceUnit
      }
    }
  }
`;

export default query;
